module.exports = __webpack_public_path__ + "static/media/orgMobile.e7ab4a67.svg";